import IconPdf from "../../Icon/IconPdf";

function FamilyTreePdfCard({ title, pdf }) {
  const baseName = pdf?.toLowerCase().endsWith(".pdf") ? pdf.slice(0, -4) : pdf;
  const displayTitle = title || baseName;
  const formattedTitle = displayTitle
    ? displayTitle.charAt(0).toUpperCase() + displayTitle.slice(1)
    : "PDF";

  return (
    <a
      href={`https://storage.strinix.com/cpm/vanshavali/${pdf}`}
      rel="noreferrer"
      target="_blank"
      className="d-block h-100"
    >
      <div
        className="rounded-2 p-3 border text-center d-flex flex-column align-items-center justify-content-center h-100"
        style={{ minHeight: "180px" }}
      >
        <IconPdf width="64" height="64" />
        <p
          className="mt-2 mb-0 fw-semibold"
          style={{ fontSize: "1rem", lineHeight: "1.3" }}
        >
          {formattedTitle}
        </p>
      </div>
    </a>
  );
}

export default FamilyTreePdfCard;
